module.exports = __webpack_public_path__ + "../../static/img/sloth-animate.5075af81.gif";